import { Link } from 'react-router-dom';
import { Truck, Store, Phone, MapPin, StickyNote, AlertTriangle } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const STATUS_STYLE = {
  confirmed: 'bg-blue-100 text-blue-800',
  scheduled: 'bg-purple-100 text-purple-800',
  delivered: 'bg-green-100 text-green-800',
};

export function DeliveryEventCard({ event }) {
  const d = event.details;
  const pickup = d.delivery_method === 'pickup';
  const Icon = pickup ? Store : Truck;

  return (
    <div className="p-3 rounded-lg border bg-card space-y-2" data-testid={`event-${event.id}`}>
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: event.color }}>
          <Icon className="h-4 w-4 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold truncate">{d.customer_name}</p>
          <p className="text-xs text-muted-foreground">{pickup ? 'Farm pickup' : 'Delivery'} · {d.order_number}</p>
        </div>
        <Badge className={`${STATUS_STYLE[d.status] || ''} text-[10px] capitalize`} data-testid={`event-status-${d.order_number}`}>{d.status}</Badge>
      </div>

      <ul className="text-xs rounded-md divide-y bg-secondary/30" data-testid={`event-items-${d.order_number}`}>
        {d.items.map((i) => (
          <li key={i.variety_name} className="flex justify-between px-2.5 py-1.5"><span>{i.variety_name}</span><span className="font-semibold">{i.quantity_m2} m²</span></li>
        ))}
        <li className="flex justify-between px-2.5 py-1.5 font-bold"><span>Total to cut</span><span>{d.total_m2} m²</span></li>
      </ul>

      <div className="text-xs text-muted-foreground space-y-1">
        <p className="flex items-center gap-1.5"><Phone className="h-3 w-3" /> <a href={`tel:${d.phone}`} className="hover:underline">{d.phone}</a></p>
        {!pickup && d.address && <p className="flex items-start gap-1.5"><MapPin className="h-3 w-3 mt-0.5 shrink-0" /> <span>{d.address}{d.delivery_zone ? ` · ${d.delivery_zone}` : ''}</span></p>}
        {d.notes && <p className="flex items-start gap-1.5"><StickyNote className="h-3 w-3 mt-0.5 shrink-0" /> <span>{d.notes}</span></p>}
        {d.admin_notes && <p className="flex items-start gap-1.5 text-foreground"><StickyNote className="h-3 w-3 mt-0.5 shrink-0" /> <span>{d.admin_notes}</span></p>}
        {d.is_preferred_only && (
          <p className="flex items-center gap-1.5 text-amber-700" data-testid={`event-unconfirmed-date-${d.order_number}`}><AlertTriangle className="h-3 w-3" /> Customer's preferred date — not yet scheduled</p>
        )}
      </div>

      <Link to="/orders" className="text-xs font-medium text-primary hover:underline" data-testid={`event-open-order-${d.order_number}`}>Open in Orders →</Link>
    </div>
  );
}
